import React, { useState, useEffect } from 'react'
const nodata = require('@/assets/imgs/empty.png')
import styles from './index.less'

const EmptyRefer = (props) => {
    return (
     <div className={styles.empty}>
       <img className={styles.image} src={nodata} alt=""/>
       <p className={styles.loadingText}>加载时间较长，请检查网络是否通畅</p>
       <div className={styles.button} onClick={() => {
         window.location.reload();
       }}>刷新看看</div>
     </div>
    )
}
export default EmptyRefer
